import React, { useEffect } from "react";
import styles from "./hub.module.scss";
import {
  createHubLayout,
  deleteHubSection,
  fetchAllHubLayouts,
  fetchHubLayout,
  hideSideMenu,
  invalidateLayoutCreation,
  invalidateHubUpdate,
  rearrangeHubLayout,
  updateHubLayout,
} from "../../redux/actions/hub";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { HubLayout, HubLayoutColumn, HubLayoutRow, ISectionDirection } from "../../types/hub";
import cx from "classnames";
import HubColumn from "./hubColumn";
import { useNavigate, useParams } from "react-router-dom";
import { EditHubMenuBar, HubMenuBar } from "./components/hubMenuBar";
import Toolbar from "src/components/toolbar";
import Slider from "src/components/slider";
import Button from "src/components/button";
import EditHub from "./components/editHub";
import _ from "lodash";
import { Input } from "src/components/input";
import { useStoreState } from "../contentMap";
import { IUseFetchProps, useFetch } from "src/components/hooks/useFetch";
import { fetchNotificationsCount } from "src/redux/actions/notifications";
import { useHubAdoption } from "src/redux/actions/adoption/hub";
import  Tooltip  from "src/components/tooltip";
import Text from "src/components/text";
import ChromeExtAlertBanner from "src/components/app/components/chromeExtAlertBanner";
import { useTransition, animated } from "@react-spring/web";
import { setChromeExtAlertBannerVisible } from "src/utils/util";

const Edithub = '/images/edithub.svg';
const Paperflite = '/images/Paperflite.png';

const Hub: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const layoutIdFromPath = _.get(params, "layoutId", "");

  const [showChromeExtAlert, setShowChromeExtAlert] = React.useState(() => {
    const stored = localStorage.getItem("showChromeExtAlert");

    if (stored === null) { // Initialize only if key is missing
      setChromeExtAlertBannerVisible(true);
      return true;
    }

    return stored === "true";
  });

  const [editLayout, setEditLayout] = React.useState(false);
  const [deleteSlider, setDeleteSlider] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [createSection, setCreateSection] = React.useState(false);
  const [showEditSection, setShowEditSection] = React.useState(false);
  const [layoutName, setLayoutName] = React.useState("");
  const account = useSelector((state: RootState) => _.get(state,"accounts.item"));
  
  const isAccountLoading = useSelector((state: RootState) => state.accounts.loading);
  const layout = useSelector((state: RootState) => state.hub?.item);
  const layouts = useSelector((state: RootState) => state.hub?.layouts);
  const layoutLoading = useSelector((state: RootState) => state.hub?.loading);
  const sections = useSelector((state: RootState) => state.hub?.sections);
  const { loading: isLayoutUpdating, succeeded: isLayoutUpdated } = useStoreState("hub.update", false);
  const { loading: fetchingLayouts, succeeded: isLayoutsFetched, error: fetchinglayoutsError } = useStoreState("hub.layoutsState", false);
  const defaultLayoutState = useSelector((state) => _.get(state, "hub.defaultLayout",{}));
  const isDefaultLayoutCreating = _.get(defaultLayoutState,"creating",false);
  const isDefaultLayoutCreated = _.get(defaultLayoutState,"succeeded",false);
  const defaultLayoutItem = _.get(defaultLayoutState,"item",null);

  const useFetchProps: IUseFetchProps = {
    action: fetchAllHubLayouts,
    loading: fetchingLayouts,
    succeeded: isLayoutsFetched,
    response: layouts,
    error: fetchinglayoutsError
  }

  const { handleFetch : fetchAllLayouts } = useFetch(useFetchProps);

  const { trackHubScreenView, trackHubSectionDeleteConfirmationScreenView, trackHubManageContentClickedEvent,
    trackHubCreateSectionClicked, 
    trackDeleteSectionClickedEvent, trackSectionMovedEvent, trackHubEditScreenView,
    trackSectionDeletedEvent, trackContentHubEditedEvent
  } = useHubAdoption();
  
  useEffect(() => {
    dispatch(fetchNotificationsCount());
    trackHubScreenView();
    if (!isLayoutsFetched) {
      fetchAllLayouts(false).then((response) => {
        handleRedirect(response);
        if(_.size(response) === 0){
          dispatch(createHubLayout());
        }
      })
    }
    else{
      handleRedirect();
    }
  }, []);

  useEffect(() => {
    setChromeExtAlertBannerVisible(showChromeExtAlert); // close the alert and set local storage
  }, [showChromeExtAlert])

  useEffect(() => {
    invalidateEdit();
  }, [layoutIdFromPath])

  useEffect(() => {
    if(editLayout){
      trackHubEditScreenView();
    }
  },[editLayout])

  useEffect(() => { 
    if(deleteSlider){
      trackHubSectionDeleteConfirmationScreenView();
      trackDeleteSectionClickedEvent();
    }

  },[deleteSlider])

  useEffect(() => {
    if (createSection) {
      trackHubCreateSectionClicked();
    }
    else if (showEditSection) {
      trackHubManageContentClickedEvent();
    }
  }, [showEditSection, createSection]);

  useEffect(() => {
      handleRedirect();
  }, [_.get(params, "layoutId", "")])

  useEffect(() => {
    if (layout && !layoutLoading && !editLayout) {
      setLayoutName(layout.layoutName);
    }
  }, [layout])

  useEffect(() => {
    if(!fetchingLayouts && isLayoutsFetched){
      if(_.size(layouts) === 0){
        dispatch(fetchHubLayout({ id : "streams" }));
      }
    }

  },[fetchingLayouts, isLayoutsFetched])

  useEffect(() => {
    if (!isLayoutUpdating && isLayoutUpdated) {
      if(showEditSection){
        setShowEditSection(false);
      }
      else{
        setEditLayout(false)
      }
      dispatch(hideSideMenu(false));
      dispatch(invalidateHubUpdate());
      setCreateSection(false);
      dispatch(fetchHubLayout({ id: layout.id }));
    }
  }, [isLayoutUpdating, isLayoutUpdated])

  useEffect(() => {

    if(!isDefaultLayoutCreating && isDefaultLayoutCreated){
      const id = _.get(defaultLayoutItem,"id","");
      if(!_.isEmpty(id)){
        navigate(`/hub/layout/${id}`);
        dispatch(invalidateLayoutCreation());
        fetchAllLayouts(false);
        localStorage.setItem("hubLayout", id);
      }
    }
  },[isDefaultLayoutCreating, isDefaultLayoutCreated])

  const chromeExtAlertBannerTransition = useTransition(showChromeExtAlert, {
    from: {
      height: 0,
      opacity: 0,
    },
    enter: {
      height: 45, // initial banner height
      opacity: 1,
    },
    leave: {
      height: 0,
      opacity: 0,
    },
    config: {
      tension: 260,
      friction: 22,
    },
  });

  const invalidateEdit = () => {
    setEditLayout(false)
    setShowEditSection(false)
    dispatch(hideSideMenu(false));
    dispatch(invalidateHubUpdate());
    setCreateSection(false);
    setCreateSection(false);
  }

  const handleRedirect = (layoutItems = layouts) => {

    if(layoutLoading || fetchingLayouts || isAccountLoading) return;

    if (_.size(layoutItems) > 0) {
      let id = "streams"; 
      if (layoutIdFromPath && isLayoutAccessible(layoutItems, layoutIdFromPath)) {
        id = layoutIdFromPath;
      } else {
        const idFromLocalStorage = localStorage.getItem("hubLayout");
        if (idFromLocalStorage && isLayoutAccessible(layoutItems, idFromLocalStorage)) {
          id = idFromLocalStorage;
        } else if (_.size(layoutItems) > 0) {
          id = layoutItems[0]?.id;
        }
      }
      dispatch(fetchHubLayout({ id }));
      if(id != layoutIdFromPath && id!== "streams"){
        navigate(`/hub/layout/${id}`);
      }
    }
  }

  const isLayoutAccessible = (layoutItems: any, id: string) => {
    return layoutItems.some((layout: any) => layout.id === id);
  }

  const deleteSection = () => {
    const layoutId = layoutIdFromPath;
    trackSectionDeletedEvent();
    dispatch(deleteHubSection({ index: activeIndex, layoutId }));
    setDeleteSlider(false);
  };

  const updateLayout = () => {
    const hubLayoutRows = layout.rows.map(row => {
      const columns = row.columns.map(column => {
        const section = sections[column.section.id];
        if (section.items != null && section.items.length > 0) {
          return {
            section: {
              id: column.section.id,
              title: _.get(column, "section.title") || null,
              contentIds: _.map(section.items, 'id'),
              smartFilter: section.smartFilter,
              entityType: _.toUpper(section.items[0].entityType),
              layoutStyle: _.get(column, "section.layoutStyle") || null,
              cardStyle: _.get(column, "section.cardStyle") || null
            },
            width: column.width
          }
        } else {
          return {
            section: {
              id: column.section.id,
              title: _.get(column, "section.title") || null,
              smartFilter: section.smartFilter,
              entityType: _.get(column, "section.entityType"),
              layoutStyle: _.get(column, "section.layoutStyle") || null,
              cardStyle: _.get(column, "section.cardStyle") || null
            }
          }
        }
      });
      return {
        columns: columns
      }
    });

    const layoutRequest = {
      id: layout.id,
      layoutName: layoutName,
      rows: hubLayoutRows,
      isCreate: false
    }
    dispatch(updateHubLayout({ layout : layoutRequest, trackHubEditedEvent : trackContentHubEditedEvent }));
  }
  
  const handleSectionMove = (direction : ISectionDirection) => {
    trackSectionMovedEvent(direction)
  }

  const isEmptySection = (sectionId: string) => {
    const section = sections[sectionId];
    if(section){
      return !section.loading && _.size(section.items) === 0;
    }
    return false;
  }

  const handleEditHubClick = () => {
    setEditLayout(true);
  }


  return (
    <>
      {chromeExtAlertBannerTransition((style, item) =>
          item ? (
            <animated.div style={style}  className={styles.chromeExtAlertContainer}>
              <ChromeExtAlertBanner onClose={() => setShowChromeExtAlert(false)}/>
            </animated.div>
          ) : <></>
      )}

      <div
          className={cx(styles.container, {
            [styles.disableScroll]: showEditSection,
          })}
      >
          <div className={cx(styles.topContainer,{
            [styles.editing] : editLayout
          })}> 
            {!editLayout && <div className={styles.header}>
              {renderCompanyLogo(account)}
              <p className={cx("noMargin", styles.heading)}>content hub</p>
              {!layoutLoading && ( <p className={cx("noMargin", styles.subHeading)}>
                {_.size(layouts) > 1 ? (
                <>
                  <span className={styles.prefix}>hub name: </span>
                  <Text className={styles.hubName} text={_.get(layout, "layoutName", "")} tooltip={{placement: "auto"}} />
                </>
                ) : (
                <p className={styles.hubLayout}>Your content&apos;s natural habitat</p>
              )}
            </p>
          )}
            </div>} 
            {editLayout &&
              <div className={styles.inputBox}>
                <Input
                  className={styles.input}
                  placeholder="Add a name.."
                  value={layoutName}
                  onChange={(e) => {
                    e.preventDefault();
                    setLayoutName(e.target.value);
                  }}
                />
              </div>
            } 
          {layout && (
              <span className={styles.actionBar}>
                <HubMenuBar
                  show={!editLayout}
                  handleEdit={handleEditHubClick}
                />
                <EditHubMenuBar
                  show={editLayout}
                  onCancel={() => {
                    setEditLayout(false)
                    dispatch(hideSideMenu(false));
                    dispatch(fetchHubLayout({ id : layoutIdFromPath }));
                  }}
                  disabled={isLayoutUpdating} 
                  onSave={()=> {
                    updateLayout();
                  }}
                />
              </span>
            )}

      </div>

      {showEditSection && (
          <EditHub
            activeIndex={activeIndex}
            hubLayout={layout}
            createSection={createSection}
            hideEditSection={() => {
              setShowEditSection(false)
              dispatch(hideSideMenu(false));
              dispatch(invalidateHubUpdate());
              setCreateSection(false);
            }} />
        )}

      <div className={cx(styles.layoutContainer)}>

            <div className={styles.hubLayoutContainer}>
              {!layoutLoading &&
                renderLayout(
                  layout,
                  editLayout,
                  dispatch,
                  setActiveIndex,
                  setCreateSection,
                  setDeleteSlider,
                  setShowEditSection,
                  handleSectionMove ,
                  isEmptySection
                )}
            </div>

            <Slider.Dialog
              width="300"
              show={deleteSlider}
              onClose={() => setDeleteSlider(false)}
            >
              <Slider.Header title="deleting..." />
              <Slider.Body>
                <p> You’re about to delete this section. No second chances.</p>
              </Slider.Body>
              <Slider.Actions>
                <Button
                  variant="primary"
                  text="Delete"
                  onClick={() => deleteSection()}
                ></Button>
                <Button
                  variant="secondary"
                  text="Cancel"
                  onClick={() => setDeleteSlider(false)}
                ></Button>
              </Slider.Actions>
            </Slider.Dialog>
          </div>
          
      </div>
    </>
  );
};

// Helper function to render company logo
function renderCompanyLogo(account) {

  const icon = account && account.logo
  ? account.logo.thumbnail
  : Paperflite;
  return (
    <div className={styles.companyLogo}>
      <img src={icon} alt="Company Logo" />
    </div>
      
  );
}

// Renders the layout of the Hub
function renderLayout(
  layout: HubLayout,
  editLayout: boolean,
  dispatch: any,
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>,
  setCreateSection: React.Dispatch<React.SetStateAction<boolean>>,
  setDeleteSlider: React.Dispatch<React.SetStateAction<boolean>>,
  setShowEditSection: React.Dispatch<React.SetStateAction<boolean>>,
  handleSectionMove: (direction : ISectionDirection) => void,
  isEmptySection: (sectionId: string) => boolean
) {
  return (
    layout?.rows?.map((row: HubLayoutRow, index: number) => (
      <div key={index} className={styles.hubLayout}>
        {renderRow(
          layout,
          row,
          index,
          editLayout,
          dispatch,
          setActiveIndex,
          setCreateSection,
          setDeleteSlider,
          setShowEditSection,
          handleSectionMove,
          isEmptySection
        )}
      </div>
    )) || null
  );
}

// Renders each row in the Hub layout
function renderRow(
  layout: HubLayout,
  row: HubLayoutRow,
  rowIndex: number,
  editLayout: boolean,
  dispatch: any,
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>,
  setCreateSection: React.Dispatch<React.SetStateAction<boolean>>,
  setDeleteSlider: React.Dispatch<React.SetStateAction<boolean>>,
  setShowEditSection: React.Dispatch<React.SetStateAction<boolean>>,
  handleSectionMove: (direction : ISectionDirection) => void,
  isEmptySection: (sectionId: string) => boolean
) {
  
  if (editLayout && _.size(row.columns) === 0) {
    return <div className={cx(styles.hubColumn, styles.editHubColumn)} >
      <div className={cx(styles.overlay, styles.emptySection)}>
        {renderEditSectionOverlay(
          layout,
          rowIndex,
          dispatch,
          setActiveIndex,
          setCreateSection,
          setDeleteSlider,
          setShowEditSection,
          handleSectionMove,
        )}
      </div>
    </div>
  }

  if (!row || !row.columns) return null;

  if(_.size(row) === 0){
    return null;
  }
  
  return row.columns.map((column: HubLayoutColumn) => {
    const isSectionEmpty = isEmptySection(_.get(column,"section.id",""));
    if(!editLayout && isSectionEmpty){
      return null;
    }

    return <div className={cx(styles.hubColumn,{
      [styles.editHubColumn]: editLayout
    })} key={column.section.id}>
      <HubColumn
        rowIndex={rowIndex}
        section={column.section}
        width={column.width}
      />
      {editLayout && (
        <div className={cx(styles.overlay, {
          [styles.emptySection]: isSectionEmpty
        })}>
          {renderEditSectionOverlay(
            layout,
            rowIndex,
            dispatch,
            setActiveIndex,
            setCreateSection,
            setDeleteSlider,
            setShowEditSection,
            handleSectionMove
          )}
        </div>
      )}
    </div>
  });
}

// Renders the overlay for editing a layout section
function renderEditSectionOverlay(
  layout: HubLayout,
  rowIndex: number,
  dispatch: any,
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>,
  setCreateSection: React.Dispatch<React.SetStateAction<boolean>>,
  setDeleteSlider: React.Dispatch<React.SetStateAction<boolean>>,
  setShowEditSection: React.Dispatch<React.SetStateAction<boolean>>,
  handleSectionMove: (direction : ISectionDirection) => void
) {

  const handleEdit = () => {
      setActiveIndex(rowIndex);
      setShowEditSection(true);
      dispatch(hideSideMenu(true));
      setCreateSection(false);
  }

  return (
    <div className={styles.editSection}>
      <div className={styles.editSectionOverlay}>
        <div className={styles.editSectionDescription}>
          <img onClick={handleEdit} width={100} height={100} src={Edithub} />
          <p className={styles.editSectionHeading}>
            {" "}
            Go wild! Move things around like furniture in The Sims.
          </p>
          <p className={styles.editSectionSubHeading}>
            Just remember where you put everything.
          </p>
        </div>
        <div className={styles.toolbarContainer}>
          <Toolbar.Container show={true} className={styles.editSectionToolbar}>
            <Tooltip content="Edit section" placement="top">
              <div className={styles.iconWrapper}>
                <Toolbar.IconButton
                  icon="paperflite-edit"
                  onClick={handleEdit}
                />
              </div>
            </Tooltip>
            <Tooltip content="Move Up" placement="top">
              <div className={styles.iconWrapper}>
                <Toolbar.IconButton
                  icon="paperflite-arrow-up"
                  onClick={() => {
                    handleSectionMove("Up");
                    dispatch(rearrangeHubLayout({ rowIndex, direction: "up" }));
                  }}
                />
              </div>
            </Tooltip>
            <Tooltip content="Move Down" placement="top">
              <div className={styles.iconWrapper}>
                <Toolbar.IconButton
                  icon="paperflite-down-arrow"
                  onClick={() => {
                    handleSectionMove("Down");
                    dispatch(
                      rearrangeHubLayout({ rowIndex, direction: "down" }),
                    );
                  }}
                />
              </div>
            </Tooltip>
            <Tooltip content="Delete" placement="top">
              <div className={styles.iconWrapper}>
                <Toolbar.IconButton
                  icon="paperflite-delete"
                  onClick={() => {
                    setDeleteSlider(true);
                    setActiveIndex(rowIndex);
                  }}
                  disabled={layout.rows.length <= 1}
                />
              </div>
            </Tooltip>
            <Tooltip content="Create new section" placement="top">
              <div
                className={styles.addSection}
                onClick={() => {
                  setActiveIndex(rowIndex);
                  setCreateSection(true);
                  setShowEditSection(true);
                  dispatch(hideSideMenu(true));
                }}
              >
                <i className="paperflite-add" />
              </div>
            </Tooltip>
          </Toolbar.Container>
        </div>
      </div>
    </div>
  );
}

export default Hub;